// App.jsx
import LandingPage from "./landingpage";
import Home_Page2 from "./Home_Page2";
import About from "./About";
import Services3 from "./Services3";
import Projects from "./Projects";
import Contact from "./Contact";
import Vendors from "./Vendors";

export default function MainPage() {
  return (
    <div>
      <Home_Page2 />
      <About noMargin />   {/* About comes right after the landing page */}
      <Services3 noMargin />
      <Vendors noMargin />
      <Projects noMargin />
      <Contact noMargin />
    </div>
  );
}
